// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/wave-ring/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteWaveRingEN: PageEntry = {
  id: "example.produkte-wellenring",
  locale: "en",
  slug: "produkte/wave-ring",
  seo: {
    title: "Wave ring | Dietz GmbH",
    description: "Shaft ring as preload element and tolerance compensation in one assembly.",
  },
  type: "post",
  h1: "Wave ring",
  intro: "Shaft ring as preload element and tolerance compensation in one assembly.",
  blocks: [
    { kind: "image", src: "/images/live/dtz-wellenring-vorspann.jpg", alt: "Wave ring", width: 1400, height: 1120 }
  ],
};
